const data = [
  { title: 'CLIENTS', value: 80, symbol: '+', duration: 5000 },
  { title: 'PROJECTS', value: 57, symbol: '+', duration: 5000 },
  { title: 'HAPPY CLIENTS', value: 100, symbol: '%', duration: 5000 },
  { title: 'Years Of Experience', value: 3, symbol: '+', duration: 5000 }
]

export default data
